CustomBackgroundOptionsView = require 'views/board-menu/custom-background-options-view'
PopOver = require 'views/lib/pop-over'
SelectBackgroundView = require 'views/board-menu/select-background-view'
Util = require 'lib/util'

module.exports = class SelectCustomBackgroundView extends SelectBackgroundView
  initialize: ->
    super
    @listenTo @model, 'change:id', @render

  events:
    'click .js-options': 'openOptions'
    'click': 'selectBackground'

  openOptions: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$('.js-options')
      view: new CustomBackgroundOptionsView({ @model, @modelCache })

  getId: ->
    @model.id



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/select-custom-background-view.coffee